import { Box, styled } from '@material-ui/core';

export const SourcesBox = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 6,
  marginTop: 8
});

export const SourceChip = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  border: '1px solid #D9D9E3',
  borderRadius: 999,
  background: '#fff',
  cursor: 'pointer',
  font: 'inherit',
  fontSize: 12,
  lineHeight: '16px',
  color: '#3F3F51',
  padding: '3px 10px',
  transition: 'all 0.2s ease',
  '&:hover': {
    background: '#F0F0F4',
    borderColor: '#B8B8C7'
  },
  '&:focus-visible': {
    outline: '2px solid #4C6FFF',
    outlineOffset: 1
  }
});
